export default "__VITE_ASSET__f709d1ab__"